import { apiFetch } from "../http";
export async function saveVkPkce(params) {
    const { baseUrl, state, codeVerifier, signal } = params;
    return apiFetch(`/user/api/auth/vk/pkce`, {
        baseUrl,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ state, code_verifier: codeVerifier }),
        signal,
    });
}
export async function consumeVkTicket(params) {
    const { baseUrl, ticket, referralCode, signal } = params;
    return apiFetch(`/user/api/auth/vk/consume`, {
        baseUrl,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ticket, ...((referralCode === null || referralCode === void 0 ? void 0 : referralCode.trim()) ? { referral_code: referralCode.trim() } : {}) }),
        signal,
    });
}
